"use strict";
require('focusin').polyfill();
var TriggerEventType = (function () {
    function TriggerEventType() {
    }
    TriggerEventType.triggerEventTypeToTriggerType = function (eventType) {
        switch (eventType) {
            case 'click':
                return 'click';
            case 'focusout':
                return 'blur';
            case 'focusin':
                return 'focus';
            case 'mouseover':
                return 'hover';
            case 'mouseout':
                return 'mouseout';
            case 'popgun-manual':
                return 'manual';
        }
    };
    TriggerEventType.CLICK = 'click';
    TriggerEventType.BLUR = 'focusout';
    TriggerEventType.FOCUS = 'focusin';
    TriggerEventType.HOVER = 'mouseover';
    TriggerEventType.MANUAL = 'popgun-manual';
    TriggerEventType.MOUSEOUT = 'mouseout';
    return TriggerEventType;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = TriggerEventType;
